import { makeObservable, action } from 'mobx';
import { Tool, type ToolContext } from './base/Tool';
import type { Element as CanvasElement } from '@/types';

export class TextTool extends Tool {
  constructor() {
    super('text', 'Text');
    makeObservable(this, {
      onStart: action,
      onMove: action,
      onEnd: action,
    });
  }

  onStart(_context: ToolContext): CanvasElement | null {
    // Text tool creates element on a single click (onEnd), not on drag.
    return null;
  }

  onMove(_context: ToolContext): CanvasElement | undefined {
    // No preview for text tool while dragging
    return undefined;
  }

  onEnd(context: ToolContext): CanvasElement | void {
    const { projectStore, uiStore } = context.rootStore;

    // If there's text currently being edited, don't create a new text element
    // Just switch to select tool (the text editing will be stopped by the blur event)
    if (uiStore.editingTextId !== null) {
      uiStore.setActiveTool('select');
      return;
    }

    // Only create new text if no text is currently being edited
    projectStore.addTextElementAndStartEditing({
      type: 'text',
      x: context.startPoint.x,
      y: context.startPoint.y,
      text: 'Text',
      width: 200, // Default width - increased for multiline
      height: 60, // Default height - increased for multiline
      style: {
        ...uiStore.persistentStyle,
        // Text specific overrides
        textAlign: 'left',
      },
    } as any);

    return;
  }

  getCursor(): string {
    return 'text';
  }

  // Override validation for text tool - no minimum distance required
  protected validateElement(_context: ToolContext): boolean {
    return true;
  }
}
